import App from "../../../package.json";

const env = process.env.REACT_APP_NODE_ENV || "qa";

// * API Config Map
const config = {
  production: {
    api: process.env.REACT_APP_API_URL_PROD,
    apiApp: process.env.REACT_APP_API_APP_URL_PROD,
  },
  qa: {
    api: process.env.REACT_APP_API_URL_QA,
    apiApp: process.env.REACT_APP_API_APP_URL_QA,
  },
  local: {
    api: process.env.REACT_APP_API_URL_LOCAL,
    apiApp: process.env.REACT_APP_API_APP_URL_LOCAL,
  },
  development: {
    api: process.env.REACT_APP_API_URL_DEV,
    apiApp: process.env.REACT_APP_API_APP_URL_DEV,
  },
}[env];

// * Export Constant
export const PACKAGE_NAME = App.name;
export const APP_VERSION = App.version;
export const IS_APP_PRODUCTION = env === "production";
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const NO_IMAGE_AVAILABLE = "https://sternbergclinic.com.au/wp-content/uploads/2020/03/placeholder.png";

// * URL
export const API_URL = config.api + "/vetEvChargerFrontendAPi";
// export const API_URL = "http://192.168.88.237:4590/vetEvChargerFrontendAPi";
export const API_APP_URL = config.apiApp + "/vetEvChargerTabletAPi";

